import React from "react";
import { Modal, Button, ButtonToolbar } from "react-bootstrap";
import { FileType } from "./constant";
import { FormMode } from "../../../constant";
import { Typeahead } from "react-bootstrap-typeahead";
import { sortAlphabetically } from "helper/utils";
import { getChecksum } from "helper/checksum";
import { validateEncryption } from "helper/validate-encryption";
import UnencryptedCheckboxAgreement from './unencrypted-checkbox'

const defaultFile = {
  id: "",
  fileName: undefined,
  releaseNote: null,
  currentReleaseNote: "",
  description: "",
  descriptionId: "",
  fileType: FileType.Firmware,
  newSWSAPNumber: "",
  sha256: "",
  fileSize: 0,
  file: null,
  unitFamilyIds: [],
  selectedFamilyNames: [],
  isEncrypted: false,
  hasSecurityPatch: null
};

class FirmwareModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: defaultFile,
      mode: FormMode.Add,
      isSaving: false,
      languageCodeId: "",
      isLoading: false,
      isAcknowledgedByUser: false
    };
    this.onTextChanged = this.onTextChanged.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onChangeIsAcknowledgedByUser = this.onChangeIsAcknowledgedByUser.bind(this);
  }

  onTextChanged(event) {
    this.setState({
      file: { ...this.state.file, [event.target.id]: event.target.value },
    });
  }

  onMultipleSelectFamilyIdsChange = (families) => {
    this.setState({
      file: {
        ...this.state.file,
        unitFamilyIds: families.map((family) => family.productId),
      },
    });
  };

  async onSave() {
    this.setState({
      isSaving: true,
    });

    const {
      id,
      fileName,
      releaseNote,
      description,
      descriptionId,
      fileType,
      newSWSAPNumber,
      sha256,
      fileSize,
      file,
      unitFamilyIds,
    } = this.state.file;

    if (this.state.mode === FormMode.Add) {
      var formData = new FormData();
      formData.append("fileType", fileType);
      formData.append("newSWSAPNumber", newSWSAPNumber);
      formData.append("releaseNote", releaseNote);
      formData.append("isEncrypted", this.state.file?.isEncrypted);
      formData.append("isAcknowledgedByUser", this.state.isAcknowledgedByUser);
      formData.append("hasSecurityPatch", this.state.file.hasSecurityPatch ?? false);

      if (description?.trim()?.length > 0)
        formData.append(
          "descriptions",
          JSON.stringify([
            {
              description: description,
              languageCodeId: this.state.languageCodeId,
            },
          ])
        );
      formData.append("sha256", sha256);
      formData.append("fileSize", fileSize);
      formData.append("file", file);
      formData.append("unitFamilyIds", JSON.stringify(unitFamilyIds));
      await this.props.onUploadFirmwareSubmit(formData, fileName);
    } else {
      var formData = new FormData();
      formData.append("id", id);
      formData.append("fileType", fileType);
      formData.append("newSWSAPNumber", newSWSAPNumber);
      formData.append("releaseNote", releaseNote);
      if (description?.trim()?.length > 0)
        formData.append(
          "descriptions",
          JSON.stringify([
            {
              id: descriptionId,
              description: description,
              languageCodeId: this.state.languageCodeId,
            },
          ])
        );
      await this.props.onUpdateFirmwareSubmit(formData, fileName);
    }

    this.setState({
      isSaving: false,
    });
  }

  getDescription = (descriptions) => {
    const selectedDescription = descriptions.filter(
      (description) => description.languageCodeId === this.state.languageCodeId
    );

    if (selectedDescription.length > 0) {
      return selectedDescription[0];
    }
    return "";
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.show && nextProps.show != this.props.show) {
      this.setState({
        file: {
          id: "",
          fileType: FileType.Firmware,
          newSWSAPNumber: "",
          description: "",
          releaseNote: null,
          currentReleaseNote: "",
          sha256: "",
          fileSize: 0,
          file: null,
          unitFamilyIds:
            nextProps.products && nextProps.products.length > 0
              ? nextProps.products.map((product) => product.productId)
              : [-1],
          fileName: undefined,
          hasSecurityPatch: null,
        },
      });
    }
    if (nextProps.languageCodes && nextProps.languageCodes.length > 0) {
      const languageCodeENarray = nextProps.languageCodes.filter(
        (languageCode) => languageCode.languageCode === "en-GB"
      );
      if (languageCodeENarray.length > 0) {
        this.setState({ languageCodeId: languageCodeENarray[0].id });
      }
    }
    if (
      nextProps.products &&
      nextProps.products.length > 0 &&
      nextProps.products.length != this.props.products.length
    ) {
      this.setState({
        file: {
          ...this.state.file,
          unitFamilyIds:
            nextProps.products && nextProps.products.length > 0
              ? nextProps.products.map((product) => product.productId)
              : [-1],
        },
      });
    }
    if (nextProps.formMode === FormMode.Add && this.state.file.id) {
      this.setState({
        mode: nextProps.formMode,
        file: defaultFile,
      });
    } else if (
      nextProps.formMode === FormMode.Edit ||
      nextProps.formMode === FormMode.View
    ) {
      this.setState({
        file: {
          id: nextProps.selectedFirmware.id,
          fileName: nextProps.selectedFirmware.fileName,
          fileType: nextProps.selectedFirmware.fileTypeKey,
          newSWSAPNumber: nextProps.selectedFirmware.newSWSAPNumber,
          releaseNote: null,
          currentReleaseNote: nextProps.selectedFirmware.releaseNote,
          description: this.getDescription(
            nextProps.selectedFirmware.descriptions
          ).description,
          descriptionId: this.getDescription(
            nextProps.selectedFirmware.descriptions
          ).id,
          sha256: nextProps.selectedFirmware.sha256,
          fileSize: nextProps.selectedFirmware.fileSize,
          hasSecurityPatch: nextProps.selectedFirmware.hasSecurityPatch,
          file: nextProps.selectedFirmware.fileName,
          unitFamilyIds: nextProps.selectedFirmware.unitFamilies.map(
            (family) => family.unitFamilyId
          ),
          selectedFamilyNames: nextProps.selectedFirmware.unitFamilies.map(
            (family) => family.unitFamilyName
          ),
        },
        mode: nextProps.formMode,
      });
    }
  }

  async handleChange(selectorFiles) {
    const blobFile = selectorFiles.files[0];
    if (selectorFiles.id === "file") {
      if (!blobFile) {
        this.setState({
          ...this.state,
          file: {
            ...this.state.file,
            file: null,
            sha256: "",
            fileSize: 0,
            fileName: undefined,
            isEncrypted: false
          },
        });
      } else {
        this.setState({
          ...this.state,
          isLoading: true,
        });

        const sha256 = await getChecksum("SHA-256", blobFile);
        const validateFile = await validateEncryption(blobFile);
        console.log("Is Encrypted:", validateFile.isEncrypted);
        this.setState({
          ...this.state,
          isLoading: false,
          file: {
            ...this.state.file,
            sha256: sha256,
            file: blobFile,
            fileName: blobFile.name,
            fileSize: blobFile.size,
            isEncrypted: validateFile.isEncrypted,
          },
          isAcknowledgedByUser: false
        });
      }
    } else if (selectorFiles.id === "releaseNote") {
      this.setState({
        ...this.state,
        file: {
          ...this.state.file,
          releaseNote: blobFile ?? null,
        },
      });
    }
  }
  
  onChangeIsAcknowledgedByUser(event) {
    this.setState({
      isAcknowledgedByUser: event.target.checked
    });
  }

  async onReleaseNotesDownload(currentReleaseNote) {
    await this.props.onReleaseNotesDownload(currentReleaseNote);
  }

  render() {
    const {
      fileName,
      currentReleaseNote,
      description,
      fileType,
      newSWSAPNumber,
      sha256,
      fileSize,
      selectedFamilyNames,
    } = this.state.file;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onModalClose}
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          {(() => {
            if (this.state.mode === FormMode.Add) {
              return (
                <Modal.Title id="contained-modal-title-lg">
                  Upload Firmware
                </Modal.Title>
              );
            } else {
              return (
                <Modal.Title id="contained-modal-title-lg">
                  Update Firmware Details
                </Modal.Title>
              );
            }
          })()}
        </Modal.Header>

        <Modal.Body>
          {(() => {
            if (this.state.mode === FormMode.Add) {
              return <label>
                    Select File 
                    {
                      this.state.file.file ? (
                        this.state.file.isEncrypted ? (
                        <span style={{ color: "green", marginLeft: "10px" }}>
                          <i className="fa fa-check" aria-hidden="true" />
                        </span>
                        ) : (
                        <span style={{ color: "orange", marginLeft: "10px" }}>
                          <i className="fa fa-exclamation-triangle" aria-hidden="true" />
                        </span>
                        )
                    ) : null
                  }
              </label>;
            } else {
              return <label>File Name</label>;
            }
          })()}

          <div className="form-group input-group col-xs-12">
            {
              this.state.mode === FormMode.Add?
                <>
                  <input
                    id="file"
                    type="file"
                    className="form-control"
                    accept=".bin,.xcbin,.raucb,.txt,.hex,.srec.pfile"
                    onChange={(e) => this.handleChange(e.target)}
                  />    
                  <UnencryptedCheckboxAgreement
                    isVisible={this.state.file?.file && !this.state.file.isEncrypted}
                    isAcknowledgedByUser={this.state.isAcknowledgedByUser}
                    onChangeIsAcknowledgedByUser={this.onChangeIsAcknowledgedByUser} // TODO
                  />
                </>
                :      
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={fileName}
                  />
            }
          </div>
          <div className="form-group">
            <label>Contains Security Update</label>
            <div>
              <label style={{ marginRight: "16px", fontWeight: "normal" }}>
                <input
                  type="radio"
                  name="hasSecurityPatch"
                  value="true"
                  checked={this.state.file.hasSecurityPatch === true}
                  onChange={() =>
                    this.setState({
                      file: { ...this.state.file, hasSecurityPatch: true },
                    })
                  }
                  disabled={this.state.mode !== FormMode.Add}
                  style={{ marginRight: "4px" }}
                />
                Yes
              </label>
              <label style={{ fontWeight: "normal" }}>
                <input
                  type="radio"
                  name="hasSecurityPatch"
                  value="false"
                  checked={this.state.file.hasSecurityPatch === false}
                  onChange={() =>
                    this.setState({
                      file: { ...this.state.file, hasSecurityPatch: false },
                    })
                  }
                  disabled={this.state.mode !== FormMode.Add}
                  style={{ marginRight: "4px" }}
                />
                No
              </label>
            </div>
            {this.state.mode === FormMode.Add && (
              <div
                style={{
                  color: "#856404",
                  backgroundColor: "#fff3cd",
                  border: "1px solid #ffc107",
                  padding: "6px 10px",
                  borderRadius: "4px",
                  marginTop: "4px",
                }}
              >
                <i
                  className="fa fa-exclamation-triangle"
                  aria-hidden="true"
                  style={{ marginRight: "6px" }}
                />
                This selection cannot be changed after upload. If an update is required, please delete the file and upload it again.
              </div>
            )}
          </div>
          <div className="form-group repeater">
            <label>Product/s</label>
            <Typeahead
              multiple
              onChange={this.onMultipleSelectFamilyIdsChange}
              labelKey="productName"
              options={sortAlphabetically(this.props.products, "productName")}
              defaultSelected={
                this.state.mode === FormMode.Add
                  ? []
                  : selectedFamilyNames
                  ? selectedFamilyNames
                  : []
              }
              disabled={this.state.mode !== FormMode.Add}
            />
          </div>
          <div className="form-group">
            <label>File Type</label>
            <select
              id="fileType"
              className="form-control"
              value={fileType}
              onChange={this.onTextChanged}
              disabled={this.state.mode === FormMode.View}
            >
              {this.props.fileTypes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>SW SAP Number and Version</label>
            <input
              id="newSWSAPNumber"
              type="text"
              className="form-control"
              value={newSWSAPNumber}
              onChange={this.onTextChanged}
              placeholder="Ex: 12345678V99.12.34.56789"
              disabled={this.state.mode !== FormMode.Add}
            />
          </div>
          <div className="form-group">
            <label>Release Notes</label>

            {(() => {
              if (
                this.state.mode === FormMode.Edit ||
                this.state.mode === FormMode.View
              ) {
                return (
                  <div>
                    <span style={{ fontWeight: "bold" }}>Current File: </span>{" "}
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.onReleaseNotesDownload(currentReleaseNote)
                      }
                      title="download"
                      disabled={this.state.mode === FormMode.View}
                    >
                      {currentReleaseNote}
                    </a>
                  </div>
                );
              }
            })()}

            <input
              id="releaseNote"
              type="file"
              className="form-control"
              onChange={(e) => this.handleChange(e.target)}
              disabled={this.state.mode === FormMode.View}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              id="description"
              type="text"
              className="form-control"
              style={{ height: 100 }}
              value={description}
              onChange={this.onTextChanged}
              disabled={this.state.mode === FormMode.View}
            />
          </div>

          <div className="form-group">
            <label>SHA256</label>
            <input
              id="sha256"
              className="form-control"
              type="text"
              disabled
              value={this.state.isLoading ? "Loading..." : sha256}
            />
          </div>
          <div className="form-group">
            <label>File Size</label>
            <input
              id="sha256"
              className="form-control"
              type="text"
              disabled
              value={this.state.isLoading ? "Loading..." : fileSize}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <ButtonToolbar className="pull-right">
            <button className="btn btn-grey" onClick={this.props.onModalClose}>
              Close
            </button>
            {this.state.mode !== FormMode.View && (
              <Button
                bsStyle="primary"
                disabled={
                  this.state.isSaving ||
                  this.state.isLoading ||
                  fileName === undefined ||
                  (this.state.mode === FormMode.Add && this.state.file.hasSecurityPatch === null) ||
                  (this.state.mode === FormMode.Add && this.state.file && !this.state.file.isEncrypted && !this.state.isAcknowledgedByUser)
                }
                onClick={() => this.onSave()}
              >
                {this.state.mode === FormMode.Add ? "Upload" : "Update"}
                {this.state.isSaving ? (
                  <span>
                    <i className="fa fa-spinner fa-spin" />
                  </span>
                ) : (
                  <span></span>
                )}
              </Button>
            )}
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default FirmwareModal;
